
const HeroSection = () => {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20">
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: 'url(https://public.readdy.ai/ai/img_res/86989cf9cbd8a4b6fee6804dded9b250.jpg)'
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-br from-navy-950/90 via-navy-900/85 to-navy-950/90"></div>

      <div className="max-w-7xl mx-auto px-6 py-20 relative z-10">
        <div className="w-full text-center">
          <h1 className="text-5xl lg:text-6xl font-extrabold leading-tight mb-6">
            <span className="text-white">Seu benefício liberando</span>
            <br />
            <span className="text-gold-400">
              dinheiro hoje
            </span>
          </h1>

          <p className="text-xl text-white/80 mb-8 max-w-2xl mx-auto leading-relaxed">
            Crédito consignado com desconto direto na folha, sem consulta ao SPC e com as menores taxas do mercado. Aprovação rápida e segura.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 mb-8 justify-center">
            <a
              href="https://wa.me/5519971344445?text=Olá! Quero falar com um especialista sobre crédito consignado."
              target="_blank"
              rel="noopener noreferrer"
              className="bg-gold-500 hover:bg-gold-600 text-navy-900 font-bold px-8 py-4 rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 flex items-center justify-center gap-2 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-whatsapp-line text-xl"></i>
              Fale com um especialista
            </a>
            <a
              href="https://wa.me/5519971344445?text=Olá! Gostaria de falar com um consultor."
              target="_blank"
              rel="noopener noreferrer"
              className="border-2 border-gold-500 text-gold-400 hover:bg-gold-500/10 font-bold px-8 py-4 rounded-lg transition-all duration-300 flex items-center justify-center gap-2 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-whatsapp-line text-xl"></i>
              Falar no WhatsApp
            </a>
          </div>

          <div className="flex flex-wrap gap-6 justify-center">
            <div className="flex items-center gap-2 text-white/80">
              <div className="w-8 h-8 bg-gold-500/20 rounded-full flex items-center justify-center">
                <i className="ri-lock-line text-gold-400"></i>
              </div>
              <span className="text-sm font-medium">100% Seguro LGPD</span>
            </div>
            <div className="flex items-center gap-2 text-white/80">
              <div className="w-8 h-8 bg-gold-500/20 rounded-full flex items-center justify-center">
                <i className="ri-time-line text-gold-400"></i>
              </div>
              <span className="text-sm font-medium">Liberado em até 48h</span>
            </div>
            <div className="flex items-center gap-2 text-white/80">
              <div className="w-8 h-8 bg-gold-500/20 rounded-full flex items-center justify-center">
                <i className="ri-shield-check-line text-gold-400"></i>
              </div>
              <span className="text-sm font-medium">Sem taxas antecipadas</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
